export default __webpack_public_path__ + "static/media/pin.560ee7f5.svg";